import { forwardRef, type CSSProperties, type ForwardedRef, type ReactNode } from "react";
import "./RotatingBorderWrapper.scss";

type RotationDirection = "clockwise" | "counterclockwise";
type AnimationType = "shimmer" | "rotate" | "sweep";

type RotatingBorderWrapperProps = {
  children: ReactNode;
  duration?: string; // e.g. "3s"
  borderWidth?: string; // e.g. "1px"
  glowColor?: string; // Main glow color
  borderRadius?: string; // e.g. "8px", "50%", "0.5rem"
  animationType?: AnimationType; // Type of border animation
  className?: string;
  pauseOnHover?: boolean;
  direction?: RotationDirection;
} & React.HTMLAttributes<HTMLDivElement>;

const RotatingBorderWrapper = forwardRef<HTMLDivElement, RotatingBorderWrapperProps>(
  (
    {
      children,
      duration = "3s",
      borderWidth = "1px",
      glowColor = "#f3123c",
      borderRadius,
      animationType = "shimmer",
      className = "",
      pauseOnHover = false,
      direction = "clockwise",
      ...props
    },
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const wrapperStyle: CSSProperties & Record<string, string | number> = {
      "--border-width": borderWidth,
      "--glow-color": glowColor,
      "--duration": duration,
      ...(borderRadius && { borderRadius }),
    };

    return (
      <div
        ref={ref}
        className={`rotating-border-wrapper ${animationType} ${
          pauseOnHover ? "pause-on-hover" : ""
        } ${direction} ${className}`}
        style={wrapperStyle}
        {...props}
      >
        {children}
      </div>
    );
  },
);

export default RotatingBorderWrapper;
